export default "__VITE_ASSET__C2DMRjxG__"